                                                 const Constants = {

  applicationName: 'RansomStop',

  customerName: 'rollins',
  apiHost: 'rollins-api',
  domainName: 'ransomstop.com',
  version: '2.3.0',
  userPoolId: 'us-east-1_SMQ8WvcD6',
  userPoolClientId: '2fgn90v4mgjoamqnrdle3na7mm',
  authDomain: 'rollins-ransomstop-com.auth.us-east-1.amazoncognito.com',
  region: 'us-east-1',
  invokeUrl: '',

}
export default Constants